import React from 'react'

const Groups = () => {
    return (
        <>
            <div className="row mt-4">
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="avatarimg"><img src="https://simulanis.blob.core.windows.net/sso/uno/development/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/58a04872-b322-4bc8-93a5-3c4a29f4d796.png" alt="Avatar for Simulanis India" title="Simulanis India" /></div>
                                <h6 class="groupname">Simulanis India</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="initials-placeholder">SI</div>
                                <h6 class="groupname">Simulanis Internal Testing</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="avatarimg"><img src="https://simulanis.blob.core.windows.net/sso/uno/development/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/58a04872-b322-4bc8-93a5-3c4a29f4d796.png" alt="Avatar for Simulanis India" title="Simulanis India" /></div>
                                <h6 class="groupname">Simulanis India</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="avatarimg"><img src="https://simulanis.blob.core.windows.net/sso/uno/development/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/58a04872-b322-4bc8-93a5-3c4a29f4d796.png" alt="Avatar for Simulanis India" title="Simulanis India" /></div>
                                <h6 class="groupname">Simulanis India</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="avatarimg"><img src="https://simulanis.blob.core.windows.net/sso/uno/development/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/58a04872-b322-4bc8-93a5-3c4a29f4d796.png" alt="Avatar for Simulanis India" title="Simulanis India" /></div>
                                <h6 class="groupname">Simulanis India</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="avatarimg"><img src="https://simulanis.blob.core.windows.net/sso/uno/development/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/58a04872-b322-4bc8-93a5-3c4a29f4d796.png" alt="Avatar for Simulanis India" title="Simulanis India" /></div>
                                <h6 class="groupname">Simulanis India</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="groupcardesign">
                                <div class="avatarimg"><img src="https://simulanis.blob.core.windows.net/sso/uno/development/teams/a980ec6b-959e-4d68-83cc-4ca888f7f936/logo/58a04872-b322-4bc8-93a5-3c4a29f4d796.png" alt="Avatar for Simulanis India" title="Simulanis India" /></div>
                                <h6 class="groupname">Simulanis India</h6>
                                <div class="groupusercount">
                                    <p><span className='text-danger'>29</span> <br /> Groups </p>
                                    <p><span className='text-danger'>8</span> <br /> Users  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Groups
